import { render, staticRenderFns } from "./DashedColor.vue?vue&type=template&id=01c6664f"
import script from "./DashedColor.vue?vue&type=script&lang=js"
export * from "./DashedColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports